import { useState } from "react";
import { Button, Input } from "components/UI/atoms";
import "./index.scss";

export const DeviceVerificationInput = ({
  validateCode,
  codeToRaiseUser = null
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const formHandleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    const { value } = event.target.elements["device_verification[code]"];

    await validateCode(value);

    setIsLoading(false);
  };

  return (
    <div className="device-verification-input">
      <form onSubmit={formHandleSubmit} name="device_verification_form">
        <p className="code">
          Code:<abbr>*</abbr>
        </p>
        <Input
          id="device_verification[code]"
          name="device_verification[code]"
          type="text"
          inputMode="numeric"
          maxLength="6"
          onInput={({ target }) =>
            (target.value = target.value.replace(/[^0-9]/g, ""))
          }
          required
        />
        <Button
          name="commit"
          type="submit"
          customClassName="verify-button"
          disabled={isLoading}
        >
          VERIFY DEVICE
        </Button>
      </form>
      {codeToRaiseUser && (
        <p className="raise-user-code">
          This is your verification code: {codeToRaiseUser}
        </p>
      )}
    </div>
  );
};
